import { render, staticRenderFns } from "./DoctorLanguages.vue?vue&type=template&id=5c9955fc&"
import script from "./DoctorLanguages.vue?vue&type=script&lang=js&"
export * from "./DoctorLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports